import { useState } from "react";
import { Lock, User, LogIn } from "lucide-react";

const CREDS = { username: "admin", password: "admin123#" };

export default function Login({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    setTimeout(() => {
      if (username.trim() === CREDS.username && password === CREDS.password) {
        localStorage.setItem("gtm_auth", "1");
        onSuccess();
      } else {
        setError("Invalid credentials. Try admin / admin123#");
        setSubmitting(false);
      }
    }, 250);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "linear-gradient(135deg, var(--navy), var(--navy2) 55%, var(--navy3))" }}
      data-testid="login-screen"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="logo-mark" />
          <div>
            <div className="text-white font-black tracking-tight leading-none" style={{ fontFamily: "Chivo", fontSize: 20 }}>
              GTM FP&A Command Center
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] mt-1" style={{ color: "var(--teal)" }}>
              Every number drills to the atomic record
            </div>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="rounded-xl p-7"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(12px)",
          }}
          data-testid="login-form"
        >
          <div className="mb-1 text-white font-bold" style={{ fontFamily: "Chivo", fontSize: 18 }}>
            Sign in
          </div>
          <div className="text-[12px] mb-6" style={{ color: "rgba(255,255,255,0.6)" }}>
            Enter your credentials to access the cockpit.
          </div>

          <label className="block text-[11px] uppercase tracking-wider mb-1" style={{ color: "rgba(255,255,255,0.7)" }}>
            Username
          </label>
          <div className="relative mb-4">
            <User size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "rgba(255,255,255,0.5)" }} />
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              placeholder="admin"
              data-testid="login-username"
              className="w-full pl-9 pr-3 py-2.5 rounded-md text-white text-sm outline-none"
              style={{
                background: "rgba(0,0,0,0.25)",
                border: "1px solid rgba(255,255,255,0.15)",
              }}
            />
          </div>

          <label className="block text-[11px] uppercase tracking-wider mb-1" style={{ color: "rgba(255,255,255,0.7)" }}>
            Password
          </label>
          <div className="relative mb-4">
            <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "rgba(255,255,255,0.5)" }} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="••••••••"
              data-testid="login-password"
              className="w-full pl-9 pr-3 py-2.5 rounded-md text-white text-sm outline-none"
              style={{
                background: "rgba(0,0,0,0.25)",
                border: "1px solid rgba(255,255,255,0.15)",
              }}
            />
          </div>

          {error && (
            <div
              className="text-[12px] mb-3 px-3 py-2 rounded-md"
              style={{ background: "rgba(239,68,68,0.15)", color: "#fecaca", border: "1px solid rgba(239,68,68,0.35)" }}
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md font-bold text-sm transition-opacity"
            style={{
              background: "var(--teal)",
              color: "var(--navy)",
              opacity: submitting ? 0.6 : 1,
            }}
          >
            <LogIn size={14} /> {submitting ? "Signing in…" : "Sign in"}
          </button>

          <div className="text-[11px] mt-5 text-center" style={{ color: "rgba(255,255,255,0.45)" }}>
            Demo credentials: <span style={{ color: "var(--teal)" }}>admin / admin123#</span>
          </div>
        </form>
      </div>
    </div>
  );
}
